module.exports = __webpack_public_path__ + "img/Stahlzaun Paneele.1276c093.jpg";